import Article from '../../../../models/article/Article';

export interface IAiForgeSummaryRequestContent {
	originalText: string | null;
	publication: string | null;
	version: string | null;
	articleId?: string | null;
	regenerate?: boolean | null;
}

export interface IAiForgeTitleRequestContent {
	body: string | null;
	version: string | null;
	publication?: string | null;
	articleId?: string | null;
	regenerate?: boolean | null;
}

export interface IAiForgeResponseContent {
	data: string[] | null;
	success: boolean | null;
}

export interface IAiAssistantContent {
	main_title: IAiAssistantExtractedContent | null;
	seo_title: IAiAssistantExtractedContent | null;
	summary: IAiAssistantExtractedContent | null;
	article: Article | null;
}

export interface IAiAssistantExtractedContent {
	extracted_content: string[] | null;
	current_content: string | null;
}

export const initialAiToolsState: Record<string, any> = {
	aiToolsOpen: false,
	aiAssistantContent: {
		main_title: { current_content: null, extracted_content: [] },
		seo_title: { current_content: null, extracted_content: [] },
		summary: { current_content: null, extracted_content: [] },
		article: null,
	},
};
